module.exports = __webpack_public_path__ + "static/img/icon2.89228b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/government/icon2.png
// module id = cWjN
// module chunks = 44